import React, { useEffect, useState } from "react";
import { Avatar } from "@mui/material";

/**
 * The training center's logo in the app header. Falls back to the center's initial when there is no logo or the
 * image can't be loaded, so a bad logo URL never shows as a broken image. Decorative: the center's name is always
 * shown next to it.
 */
export default function TenantLogo({ src, name, size, color }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);

  if (src && !failed) {
    return (
      <img data-testid="tenant-logo" src={src} alt="" onError={() => setFailed(true)}
        style={{ height: size, width: size, objectFit: "contain", borderRadius: 9 }} />
    );
  }
  return (
    <Avatar sx={{ width: size, height: size, borderRadius: "9px", bgcolor: color, fontSize: size > 32 ? "0.85rem" : "0.8rem", fontWeight: 800 }}>
      {(name || "T")[0]}
    </Avatar>
  );
}
